export const WHITELABELED_FOOTER = {
  PURCHASE_MESSAGE: "Want to remove 'Powered by EXLY'? from footer",
  PROCEED_MESSAGE: "Yes",
  REJECT_MESSAGE: "No",
};

export const UNLOCK_WHITELABELED_MESSAGES = {
  SEO_MESSAGE: "Edit SEO Page Details via White-labelling",
  BR_COMMUNITY_MESSSAGE:
    "Edit Branded Community Page Details via White-labelling",
  RC_MESSSAGE: "Edit Recorded Content Page Details via White-labelling",
  HOME_PAGE_MESSAGE: "Edit Home Page Details via White-labelling",
  LANDING_PAGE_MESSAGE: "Edit Landing Page Details via White-labelling",
  CHECKOUT_PAGE_MESSAGE: "Edit Checkout Page Details via White-labelling",
  THANK_YOU_PAGE_MESSAGE: "Edit Thank You Page Details via White-labelling",
};

export const WHITELABELED_SEO = {
  PURCHASE_MESSAGE: "Want to remove 'Powered by EXLY'? from description",
};

export const WHITELABELED_DOMAIN_LINK = {
  PURCHASE_MESSAGE: "Want to connect your 'Own Domain'?",
  CONNECTED: {
    description: "Domain linked successfully!",
    linkLabel: "View Details",
    link: "/#/Integrations/domain_linking",
  },
  DISCONNECTED: {
    description: "Want to connect your domain?",
    linkLabel: "Click here",
    link: "/#/Integrations/domain_linking",
  },
};
